module.exports = __webpack_public_path__ + "static/media/walber.03201bf2.svg";